import { render, staticRenderFns } from "./Slideshow.vue?vue&type=template&id=ff146002&scoped=true&"
import script from "./Slideshow.vue?vue&type=script&lang=ts&"
export * from "./Slideshow.vue?vue&type=script&lang=ts&"
import style0 from "./Slideshow.vue?vue&type=style&index=0&id=ff146002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff146002",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VIcon})
